// Shared-component strings, namespaced as 'components.<componentName>.<key>'.
// Auto-compiled from the i18n-full-app-coverage workflow run.
export default {
  'components.cleanTextContextMenu.copy': 'Salin teks bersih',
  'components.cleanTextContextMenu.copied': 'Teks bersih disalin',
  'components.cleanTextContextMenu.failed': 'Tidak dapat menyalin teks. Sila cuba lagi.',
  'components.addToMattersPopover.selectMattersLabel': 'Pilih perkara:',
  'components.addToMattersPopover.searchPlaceholder': 'Cari perkara...',
  'components.addToMattersPopover.updateSuccess': 'Perkara berjaya dikemas kini',
  'components.addToMattersPopover.updateError': 'Gagal mengemas kini perkara',
  'components.billingRequiredOverlay.defaultMessage':
    'Pengebilan organisasi anda memerlukan perhatian sebelum tindakan ini boleh diteruskan. Sila hubungi pentadbir organisasi anda.',
  'components.billingRequiredOverlay.title': 'Pengebilan diperlukan',
  'components.billingRequiredOverlay.manageBillingButton': 'Urus pengebilan',
  'components.chat.jsonResponseTitle': 'Respons JSON',
  'components.chat.dataOpenedInNewTab': 'Data dibuka dalam tab baharu',
  'components.chat.textResponseTitle': 'Respons Teks',
  'components.chat.contentOpenedInNewTab': 'Kandungan dibuka dalam tab baharu',
  'components.chat.fileOpenedInNewTab': 'Fail dibuka dalam tab baharu',
  'components.chat.failedToOpenNewTab': 'Gagal membuka tab baharu',
  'components.chat.failedToFetchUrl': 'Gagal mendapatkan URL: {message}',
  'components.chat.referenceDocumentFallback': 'Dokumen rujukan',
  'components.chat.sourcesCount': 'Sumber ({count})',
  'components.chat.referencesCount': '{count} rujukan',
  'components.chat.htmlContentTitle': 'Kandungan HTML',
  'components.chat.showMoreLines': 'Tunjuk lagi ({count} baris)',
  'components.chatWidget.waitingMessage.justAMoment': 'Sekejap...',
  'components.chatWidget.waitingMessage.fetchingThatForYou': 'Sedang mendapatkannya untuk anda...',
  'components.chatWidget.waitingMessage.hangTight':
    'Sabar sebentar, saya sedang mengusahakannya...',
  'components.chatWidget.waitingMessage.letMeCheck': 'Biar saya semak...',
  'components.chatWidget.waitingMessage.thisWillJustTakeASecond':
    'Ini hanya mengambil masa sesaat...',
  'components.chatWidget.closeChatAriaLabel': 'Tutup sembang',
  'components.chatWidget.openChatAriaLabel': 'Buka sembang',
  'components.chatWidget.processingTooltip': 'Sembang akan tersedia setelah pemprosesan selesai',
  'components.chatWidget.messageCopied': 'Mesej disalin!',
  'components.chatWidget.copyMessageFailed': 'Gagal menyalin mesej',
  'components.chatWidget.header.title': 'Sembang',
  'components.chatWidget.emptyState.title': 'Bagaimana saya boleh membantu?',
  'components.chatWidget.inputPlaceholder': 'Taip mesej...',
  'components.chatWidget.showMoreLines': 'Tunjuk lagi ({count} baris)',
  'components.chatWidget.invalidFileUrl': 'URL fail tidak sah atau tiada',
  'components.chatWidget.fileDownloadedSuccessfully': 'Fail berjaya dimuat turun',
  'components.chatWidget.fileDownloadFailed': 'Gagal memuat turun fail: {message}',
  'components.chatWidget.unnamedFile': 'fail',
  'components.chatWidget.attachmentImageAlt': 'lampiran',
  'components.checklistCard.heading': 'Senarai Semak',
  'components.downloadLoadingMask.downloading': 'Memuat turun...',
  'components.emlViewer.fromLabel': 'Daripada:',
  'components.emlViewer.toLabel': 'Kepada:',
  'components.emlViewer.ccLabel': 'Sk:',
  'components.emlViewer.dateLabel': 'Tarikh:',
  'components.emlViewer.attachmentsLabel': 'Lampiran:',
  'components.filesSidePanel.favoritesButton': 'Kegemaran',
  'components.filesSidePanel.historyButton': 'Sejarah',
  'components.filesSidePanel.untitledPlaceholder': '(Tanpa Tajuk)',
  'components.filesSidePanel.membersPopoverTitle': 'Ahli',
  'components.filesSidePanel.ownerTag': 'Pemilik',
  'components.filesSidePanel.modifyGroupTooltip': 'Ubah Suai Kumpulan',
  'components.filesSidePanel.privateGroupWarningTooltip':
    'Kurang selamat: Kelihatan oleh kumpulan anda.',
  'components.filesSidePanel.firmWideWarningTooltip':
    'Sangat tidak selamat: Kelihatan oleh firma anda.',
  'components.filesSidePanel.publicWarningTooltip':
    'Sangat tidak selamat: Kelihatan oleh semua orang.',
  'components.filesSidePanel.sortByDateLabel': 'Isih mengikut Tarikh (Baharu ke Lama)',
  'components.filesSidePanel.sortAlphabeticallyLabel': 'Isih mengikut Abjad (A-Z)',
  'components.gettingStartedTour.insiderHero.openLinkLabel': 'Buka A&GEL Insider',
  'components.gettingStartedTour.insiderHero.logoAlt': 'A&GEL Insider',
  'components.gettingStartedTour.insiderHero.heroTitle': 'Mempelajari alat baharu mengambil masa',
  'components.gettingStartedTour.insiderHero.basicsCard.copy':
    'Segala yang anda perlukan dari hari pertama.',
  'components.gettingStartedTour.insiderHero.basicsCard.cta': 'Mulakan dengan Asas',
  'components.gettingStartedTour.insiderHero.learnMoreCard.copy':
    'Ciri lanjutan jika anda ingin pergi lebih jauh.',
  'components.gettingStartedTour.insiderHero.learnMoreCard.cta': 'Ketahui Lebih Lanjut',
  'components.gettingStartedTour.insiderHero.whatsNewCard.copy':
    'Pelancaran dan kemas kini terkini.',
  'components.gettingStartedTour.insiderHero.whatsNewCard.cta': 'Apa yang Baharu',
  'components.gettingStartedTour.insiderHero.marinaAlt': 'Panorama Marina',
  'components.gettingStartedTour.insiderHero.featuredArticleLabel': 'Artikel Pilihan',
  'components.gettingStartedTour.insiderHero.filesUpload.title': 'Muat Naik Fail',
  'components.gettingStartedTour.insiderHero.filesUpload.description':
    'Muat naik keseluruhan fail e-mel ke dalam A&GEL, termasuk lampiran, dan gunakannya seperti mana-mana dokumen lain.',
  'components.gettingStartedTour.insiderHero.filesUpload.cta': 'Lihat Lagi',
  'components.gettingStartedTour.allCompleted.title':
    'Anda telah melengkapkan lawatan penuh A&GEL!',
  'components.gettingStartedTour.allCompleted.redoButton': 'Ulang lawatan',
  'components.gettingStartedTour.heading': 'Bermula',
  'components.gettingStartedTour.tourStyles.stepIndicator': 'Langkah {current} daripada {total}',
  'components.gettingStartedTour.tourStyles.nextDefault': 'Seterusnya →',
  'components.gettingStartedTour.chatTour.step1.title':
    'Kami telah memuatkan contoh NDA untuk anda. Klik Konteks untuk melihatnya.',
  'components.gettingStartedTour.chatTour.step1.text':
    'Di sinilah anda mengurus dokumen yang dirujuk oleh A&GEL semasa menjawab.',
  'components.gettingStartedTour.chatTour.step2.title': 'Inilah dokumen yang anda muatkan.',
  'components.gettingStartedTour.chatTour.step2.text':
    'Anda boleh memuat naik fail atau memilih daripada Peti Simpanan anda. Tutup panel apabila sedia.',
  'components.gettingStartedTour.chatTour.step2.nextLabel': 'Tutup & Teruskan →',
  'components.gettingStartedTour.chatTour.step3.title':
    'Kami telah menyediakan soalan untuk anda. Klik Hantar untuk bertanya tentang NDA tersebut.',
  'components.gettingStartedTour.chatTour.sampleQuestionDisplay':
    'Apakah kewajipan kerahsiaan dalam perjanjian ini?',
  'components.gettingStartedTour.chatTour.step4.title':
    'Jawapan yang bagus! Sekarang klik nombor rujukan (cth. [1]) untuk melihat dokumen sumber.',
  'components.gettingStartedTour.chatTour.step4.text':
    'Rujukan memaut kembali ke bahagian tepat dokumen yang digunakan oleh AI.',
  'components.gettingStartedTour.chatTour.completeModal.title': 'Syabas!',
  'components.gettingStartedTour.chatTour.completeModal.description':
    'Anda telah bertanya soalan pertama anda dalam Sembang dan mendapat jawapan bersumber.',
  'components.gettingStartedTour.tourComplete.progressText':
    '{completedCount} daripada 5 ciri selesai',
  'components.gettingStartedTour.tourComplete.completeButton': 'Selesai',
  'components.gettingStartedTour.tourComplete.continueButton': 'Teruskan ke {title} →',
  'components.gettingStartedTour.playbookTour.completeModal.title': 'Syabas!',
  'components.gettingStartedTour.playbookTour.completeModal.description':
    'Anda telah menggunakan pindaan dengan Workstudio.',
  'components.gettingStartedTour.playbookTour.step1.title':
    'Kami telah memuatkan contoh perjanjian vendor yang memerlukan pindaan.',
  'components.gettingStartedTour.playbookTour.step1.text':
    'Anda ialah vendor (Pand.ai) yang meminta terma yang lebih menguntungkan daripada klien.',
  'components.gettingStartedTour.playbookTour.step1.openingLabel': 'Membuka…',
  'components.gettingStartedTour.playbookTour.step1.openSampleLabel': 'Buka contoh →',
  'components.gettingStartedTour.playbookTour.step2.title':
    'Kami telah merangka 3 permintaan pindaan:',
  'components.gettingStartedTour.playbookTour.step2.item1': '• Pemilikan IP bersama (Klausa 17)',
  'components.gettingStartedTour.playbookTour.step2.item2':
    '• Tambah tempoh pemulihan 14 hari (Klausa 8)',
  'components.gettingStartedTour.playbookTour.step2.item3':
    '• Persempit larangan bersaing (Klausa 27)',
  'components.gettingStartedTour.playbookTour.step2.text':
    'Mod berbilang langkah memproses setiap satu secara selari untuk hasil yang lebih pantas.',
  'components.gettingStartedTour.playbookTour.step3.title': 'Klik Hantar untuk menjana pindaan.',
  'components.gettingStartedTour.playbookTour.step3.text':
    'A&GEL akan menunjukkan perubahan terjejak yang boleh anda terima, tolak atau muat turun.',
  'components.gettingStartedTour.playbookTour.step4.title':
    'Inilah pindaan yang dirangka A&GEL daripada gesaan anda.',
  'components.gettingStartedTour.playbookTour.step4.text':
    'Setiap kad menunjukkan teks asal dan perubahan yang dicadangkan.',
  'components.gettingStartedTour.playbookTour.step5.title':
    'Semak pindaan ini dan terima atau tolaknya.',
  'components.gettingStartedTour.playbookTour.step5.text':
    'Anda boleh mengulangi ini untuk yang selebihnya kemudian.',
  'components.gettingStartedTour.reviewTour.completeModal.title': 'Mengagumkan!',
  'components.gettingStartedTour.reviewTour.completeModal.description':
    'Anda telah mencipta Senarai Soalan dan menyemak dokumen dengannya.',
  'components.gettingStartedTour.reviewTour.step1.title':
    'Semakan menjawab soalan anda merentasi berbilang dokumen menggunakan Senarai Soalan.',
  'components.gettingStartedTour.reviewTour.step1.text':
    'Anda boleh mencipta senarai anda sendiri atau menggunakan yang sedia ada.',
  'components.gettingStartedTour.reviewTour.step2.title':
    'Semak imbas Senarai Soalan pra-bina mengikut kategori.',
  'components.gettingStartedTour.reviewTour.step3.title':
    'Mari cipta senarai anda sendiri. Klik di sini untuk memulakan Senarai Soalan baharu.',
  'components.gettingStartedTour.reviewTour.step4.title':
    'Pilih kategori untuk menyusun senarai anda.',
  'components.gettingStartedTour.reviewTour.step5.title':
    'Berikut beberapa contoh soalan, ditambah ke senarai anda sebagai baris yang boleh disunting.',
  'components.gettingStartedTour.reviewTour.step6.title':
    'Soalan anda muncul di sini sebagai baris yang boleh disunting. Anda boleh membuangnya bila-bila masa atau menambah seksyen untuk mengumpulkannya.',
  'components.gettingStartedTour.reviewTour.step7.title':
    'Terangkan tujuan senarai ini — sesuaikan dengan keperluan anda.',
  'components.gettingStartedTour.reviewTour.step8.title':
    'Laraskan cara AI menjawab — nada, format, tahap perincian.',
  'components.gettingStartedTour.reviewTour.step9.title':
    'Simpan senarai anda untuk menggunakannya pada dokumen.',
  'components.gettingStartedTour.reviewTour.step10.title':
    'Kami telah memuatkan beberapa contoh dokumen untuk anda cuba.',
  'components.gettingStartedTour.reviewTour.step10.text':
    'Senarai Soalan anda sedia untuk dijalankan ke atasnya.',
  'components.gettingStartedTour.reviewTour.step11.title':
    'Tekan Hantar untuk menjalankan semakan merentasi semua dokumen.',
  'components.gettingStartedTour.reviewTour.step12.title':
    'Setiap baris ialah satu soalan, setiap lajur ialah satu dokumen. Jawapan diekstrak secara automatik.',
  'components.gettingStartedTour.reviewTour.step13.title':
    'Klik mana-mana jawapan untuk melihat dengan tepat dari mana ia datang.',
  'components.gettingStartedTour.reviewTour.step14.title':
    'Klik nombor rujukan untuk terus ke petikan tepat dalam dokumen sumber.',
  'components.gettingStartedTour.reviewTour.step15.title':
    'Itulah aliran Semakan yang penuh — sumber sentiasa satu klik sahaja. Anda sudah selesai!',
  'components.gettingStartedTour.reviewTour.step15.nextLabel': 'Tamat',
  'components.gettingStartedTour.scribeTour.completeModal.title': 'Syabas!',
  'components.gettingStartedTour.scribeTour.completeModal.description':
    'Anda telah mentranskripsi audio dengan Scribe.',
  'components.gettingStartedTour.scribeTour.step1.title':
    'Pilih tujuan anda menggunakan transkripsi ini.',
  'components.gettingStartedTour.scribeTour.step1.text':
    'Ini membantu A&GEL memformat output. "Nota Mesyuarat" telah pun dipilih.',
  'components.gettingStartedTour.scribeTour.step2.title': 'Bahasa ditetapkan kepada "Auto-kesan".',
  'components.gettingStartedTour.scribeTour.step2.text':
    'Anda juga boleh mendayakan Terjemahan Langsung untuk melihat terjemahan secara masa nyata.',
  'components.gettingStartedTour.scribeTour.step3.title':
    'Klik butang rakam, atau muat naik fail audio sedia ada.',
  'components.gettingStartedTour.scribeTour.step4.title':
    'Klik Henti apabila anda sedia untuk menyimpan transkrip.',
  'components.gettingStartedTour.scribeTour.step5.title':
    'Taip nama untuk transkrip anda, kemudian klik Simpan.',
  'components.gettingStartedTour.scribeTour.step6.title':
    'Klik mana-mana baris transkrip untuk memainkan audio dari titik tersebut.',
  'components.gettingStartedTour.scribeTour.step7.title':
    'Klik Sunting untuk mengubah suai transkrip.',
  'components.gettingStartedTour.scribeTour.step7.text':
    'Perubahan anda dipaparkan dalam warna emas.',
  'components.gettingStartedTour.scribeTour.step8.title':
    'Klik Simpan untuk mengekalkan perubahan anda.',
  'components.gettingStartedTour.scribeTour.step8.text':
    'Suntingan anda dipaparkan dalam warna emas sebelum disimpan.',
  'components.gettingStartedTour.searchTour.completeModal.title': 'Bagus!',
  'components.gettingStartedTour.searchTour.completeModal.description':
    'Anda telah mencari merentasi dokumen dan menemui klausa yang berkaitan.',
  'components.gettingStartedTour.searchTour.step1.title':
    'Kami telah menyediakan pertanyaan carian untuk anda.',
  'components.gettingStartedTour.searchTour.step1.text':
    'Klik Cari atau tekan Enter untuk mencari klausa yang sepadan.',
  'components.gettingStartedTour.searchTour.step2.title':
    'Inilah padanan daripada NDA tersebut. Klik dokumen itu untuk melihat semua padanan di dalamnya.',
  'components.gettingStartedTour.searchTour.step3.title':
    'Klik mana-mana bahagian untuk terus ke seksyen tersebut dalam dokumen.',
  'components.gettingStartedTour.searchTour.step3.text':
    'Di sebelah kiri anda melihat petikan yang sepadan. Di sebelah kanan ialah dokumen penuh dengan kata kunci yang diserlahkan.',
  'components.gettingStartedTour.tourButton.label': 'Lawatan',
  'components.gettingStartedTour.tourCompleteModal.features.chat': 'Tanya soalan dalam Sembang',
  'components.gettingStartedTour.tourCompleteModal.features.search': 'Cari merentasi dokumen',
  'components.gettingStartedTour.tourCompleteModal.features.scribe': 'Transkripsi dengan Scribe',
  'components.gettingStartedTour.tourCompleteModal.features.review': 'Analisis dengan Semakan',
  'components.gettingStartedTour.tourCompleteModal.features.playbook':
    'Guna pindaan dalam Workstudio',
  'components.gettingStartedTour.tourCompleteModal.title': 'Anda sudah bersedia!',
  'components.gettingStartedTour.tourCompleteModal.subtitle':
    'Anda telah melengkapkan lawatan A&GEL dan mempelajari cara untuk:',
  'components.gettingStartedTour.tourCompleteModal.progressText': '5 daripada 5 ciri selesai',
  'components.gettingStartedTour.tourCompleteModal.ctaButton': 'Mula Menggunakan A&GEL →',
  'components.gettingStartedTour.tourCompleteModal.userGuidePrefix': 'Perlukan bantuan? Lawati ',
  'components.gettingStartedTour.tourCompleteModal.userGuideLabel': 'Panduan Pengguna',
  'components.lLMMetrics.status.fast': 'PANTAS',
  'components.lLMMetrics.status.slow': 'PERLAHAN',
  'components.lLMMetrics.status.busy': 'SIBUK',
  'components.lLMMetrics.status.pending': 'MENUNGGU',
  'components.lLMMetrics.status.loading': 'MEMUATKAN',
  'components.lLMMetrics.metricBox.defaultChartLabel': 'Nilai',
  'components.management.passwordModal.usernameColumn': 'Nama Pengguna',
  'components.management.passwordModal.passwordColumn': 'Kata Laluan',
  'components.management.passwordModal.createHeader':
    'Anda telah berjaya mencipta pengguna dengan kelayakan di bawah:',
  'components.management.passwordModal.emailChangeHeader':
    'Anda telah berjaya menukar e-mel pengguna. Kelayakan baharu di bawah:',
  'components.management.passwordModal.changePasswordNotice':
    '*Pengguna perlu menukar kata laluan mereka selepas log masuk pertama',
  'components.menuPanel.untitledItem': '(Tanpa Tajuk)',
  'components.menuPanel.renameFailed': 'Gagal menamakan semula',
  'components.menuPanel.deleteConfirm.title': 'Padam Item Sejarah',
  'components.menuPanel.deleteConfirm.content':
    'Adakah anda pasti mahu memadam item sejarah ini? Tindakan ini tidak boleh dibatalkan.',
  'components.menuPanel.deleteConfirm.createdLabel': 'Dicipta:',
  'components.menuPanel.deleteSuccess': 'Item sejarah berjaya dipadam',
  'components.menuPanel.deleteFailed': 'Gagal memadam item sejarah',
  'components.menuPanel.searchHistoryButton': 'Cari Sejarah',
  'components.menuPanel.historyLabel': 'Sejarah',
  'components.menuPanel.showAllButton': 'Tunjukkan Semua',
  'components.menuPanel.showFavoritesButton': 'Tunjukkan Kegemaran',
  'components.menuPanel.endOfListMessage': '- Ini adalah penghujungnya -',
  'components.message.enhanceGpt.modalTitle': 'Pertingkatkan Respons GPT',
  'components.message.enhanceGpt.successMessage': 'Respons baharu direkodkan',
  'components.message.enhanceGpt.questionLabel': 'Soalan: {question}',
  'components.message.enhanceGpt.answerLabel': 'Jawapan',
  'components.message.postback.clickedLabel': 'Diklik:',
  'components.message.postback.chatbotButtonFallback': 'Butang Chatbot',
  'components.message.locationLabel': 'Lokasi',
  'components.message.stickerLabel': 'Pelekat',
  'components.message.audiosLabel': 'Audio',
  'components.message.imagesLabel': 'Imej',
  'components.message.videosLabel': 'Video',
  'components.msgViewer.fromLabel': 'Daripada:',
  'components.msgViewer.toLabel': 'Kepada:',
  'components.msgViewer.attachmentsLabel': 'Lampiran:',
  'components.pdfViewerWithHighlight.renderError': 'Gagal memaparkan PDF',
  'components.promptSelector.copySuccess': 'Gesaan disalin!',
  'components.promptSelector.copyError': 'Gagal menyalin gesaan',
  'components.promptSelector.noResultsFiltered':
    'Tiada gesaan ditemui yang sepadan dengan penapis anda',
  'components.promptSelector.startTyping': 'Mula menaip untuk mencari gesaan',
  'components.promptSelector.promptLoaded': 'Gesaan telah dimuatkan!',
  'components.promptSelector.untitledPrompt': 'Gesaan Tanpa Tajuk',
  'components.promptSelector.actionPlaceholder': 'Tindakan',
  'components.promptSelector.actionOption.summarise': 'Ringkaskan',
  'components.promptSelector.actionOption.review': 'Semak',
  'components.promptSelector.actionOption.amend': 'Pinda',
  'components.promptSelector.actionOption.draft': 'Rangka',
  'components.promptSelector.actionOption.redFlagging': 'Penandaan Risiko',
  'components.promptSelector.audiencePlaceholder': 'Khalayak',
  'components.promptSelector.audienceOption.personal': 'Peribadi',
  'components.promptSelector.audienceOption.group': 'Kumpulan',
  'components.promptSelector.audienceOption.public': 'Awam',
  'components.promptSelector.selectPromptHint':
    'Pilih gesaan untuk memuatkannya ke dalam kotak input',
  'components.promptSelector.usePromptButton': 'Guna Gesaan',
  'components.promptSelector.authorLabel': 'Penulis',
  'components.promptSelector.promptLabel': 'Gesaan',
  'components.promptSelector.tagsLabel': 'Tag',
  'components.promptSelector.documentsAttached': '{count} dokumen akan dilampirkan',
  'components.questionListSelection.untitledQuestionList': '(Tanpa Tajuk)',
  'components.questionListSelection.questionCount': '{count} Soalan',
  'components.questionListSelection.accessPublicTag': 'Awam',
  'components.questionListSelection.accessFirmTag': 'Firma',
  'components.questionListSelection.accessGroupTag': 'Kumpulan peribadi',
  'components.questionListSelection.viewLess': 'Lihat Kurang',
  'components.questionListSelection.viewAll': 'Lihat Semua',
  'components.questionListSelection.whatsNewButton': 'Apa yang Baharu',
  'components.questionListSelection.tourTooltip': 'Ikuti lawatan',
  'components.questionListSelection.tourButton': 'Lawatan',
  'components.questionListSelection.sortMostPopular': 'Isih: Paling Popular',
  'components.questionListSelection.sortNameAsc': 'Isih: Nama A-Z',
  'components.questionListSelection.sortNameDesc': 'Isih: Nama Z-A',
  'components.questionListSelection.filterByAudiencePlaceholder': 'Tapis mengikut Khalayak',
  'components.questionListSelection.audienceOptionPersonal': 'Peribadi',
  'components.questionListSelection.audienceOptionPublic': 'Awam',
  'components.questionListSelection.filterByAuthorPlaceholder': 'Tapis mengikut Penulis',
  'components.reference.unknownAuthor': 'Tidak diketahui',
  'components.reference.timeAgo.justNow': 'Baru sahaja',
  'components.reference.timeAgo.minutesAgo':
    '{count, plural, one {# minit lalu} other {# minit lalu}}',
  'components.reference.timeAgo.hoursAgo': '{count, plural, one {# jam lalu} other {# jam lalu}}',
  'components.reference.timeAgo.daysAgo': '{count, plural, one {# hari lalu} other {# hari lalu}}',
  'components.reference.openCellDetails': 'Buka butiran sel',
  'components.reference.answerLabel': 'Jawapan: ',
  'components.reference.explanationLabel': 'Penjelasan',
  'components.reference.verifiedLabel': 'Disahkan',
  'components.reference.verifyLabel': 'Sahkan',
  'components.reference.pleaseEnterComment': 'Sila masukkan komen',
  'components.reference.matrixIdRequired':
    'ID Matriks diperlukan. Sila pastikan prop matrixId dihantar kepada komponen Reference.',
  'components.reference.commentAddedSuccess': 'Komen berjaya ditambah',
  'components.reference.failedToAddComment': 'Gagal menambah komen',
  'components.reference.commentUpdatedSuccess': 'Komen berjaya dikemas kini',
  'components.reference.updateOwnCommentsOnly': 'Anda hanya boleh mengemas kini komen anda sendiri',
  'components.reference.failedToUpdateComment': 'Gagal mengemas kini komen',
  'components.reference.commentDeletedSuccess': 'Komen berjaya dipadam',
  'components.reference.deleteOwnCommentsOnly': 'Anda hanya boleh memadam komen anda sendiri',
  'components.reference.failedToDeleteComment': 'Gagal memadam komen',
  'components.reference.deleteComment.title': 'Padam komen',
  'components.reference.deleteComment.description': 'Adakah anda pasti mahu memadam komen ini?',
  'components.reference.addCommentPlaceholder': 'Tambah komen...',
  'components.reference.cellsSelected':
    '{count, plural, one {# sel dipilih.} other {# sel dipilih.}}',
  'components.reference.selectCellAriaLabel': 'Pilih sel',
  'components.reference.selectQuestionRowAriaLabel': 'Pilih baris soalan',
  'components.reference.selectDocumentColumnAriaLabel': 'Pilih lajur dokumen',
  'components.reference.selectDocumentRowAriaLabel': 'Pilih baris dokumen',
  'components.reference.selectQuestionColumnAriaLabel': 'Pilih lajur soalan',
  'components.reference.documentsHeader': 'Dokumen',
  'components.reference.addRow': 'Tambah Baris',
  'components.reference.addColumn': 'Tambah Lajur',
  'components.reference.inverse': 'Songsang',
  'components.reference.showAllColumns': 'Tunjukkan Semua Lajur',
  'components.reference.showAllRows': 'Tunjukkan Semua Baris',
  'components.reference.resetView': 'Set Semula Paparan',
  'components.reference.summaryView': 'Paparan Ringkasan',
  'components.reference.exactQuote': 'Petikan Tepat',
  'components.reference.exactQuoteView': 'Paparan Petikan Tepat',
  'components.reference.detailedView': 'Paparan Terperinci',
  'components.reference.exitSelectMode': 'Keluar',
  'components.reference.chatWithSelectedOutput': 'Sembang dengan Output Terpilih',
  'components.reference.selectCells': 'Pilih Sel',
  'components.referencePopover.fileLinkUnavailable': 'Pautan fail tidak tersedia',
  'components.referencePopover.failedToOpenNewTab': 'Gagal membuka tab baharu',
  'components.referencePopover.failedToOpenFile': 'Gagal membuka fail',
  'components.referencePopover.openInNewTab': 'Buka dokumen dalam tab baharu ↗',
  'components.rightContent.organisationSwitcher.switching': 'Menukar organisasi...',
  'components.rightContent.organisationSwitcher.switchSuccess': 'Organisasi berjaya ditukar',
  'components.rightContent.organisationSwitcher.switchNoToken':
    'Penukaran organisasi tidak memulangkan token baharu',
  'components.rightContent.organisationSwitcher.switchError': 'Gagal menukar organisasi',
  'components.rightContent.organisationSwitcher.unknownOrg': 'Org Tidak Diketahui',
  'components.rightContent.organisationSwitcher.defaultLabel': 'Org',
  'components.rightContent.organisationSwitcher.tooltipFallback': 'Tukar Organisasi',
  'components.rightContent.userGuideButton.label': 'A&GEL Insider',
  'components.rightContent.angelTeamsButton.label': 'Hubungi Kami',
  'components.rightContent.reportBug.label': 'Laporkan pepijat',
  'components.rightContent.reportBug.modalDescription':
    'Beritahu kami apa yang anda hadapi dengan mengisi borang di bawah.',
  'components.rightContent.reportBug.contactSectionTitle': 'Hubungan',
  'components.rightContent.reportBug.bugDescriptionSectionTitle': 'Penerangan Pepijat',
  'components.rightContent.reportBug.environmentSectionTitle': 'Persekitaran',
  'components.rightContent.reportBug.namePlaceholder': 'Masukkan nama anda',
  'components.rightContent.reportBug.nameRequired': 'Sila masukkan nama anda',
  'components.rightContent.reportBug.emailLabel': 'E-mel',
  'components.rightContent.reportBug.emailPlaceholder': 'Masukkan e-mel anda',
  'components.rightContent.reportBug.emailRequired': 'Sila masukkan e-mel anda',
  'components.rightContent.reportBug.emailInvalid': 'Sila masukkan e-mel yang sah',
  'components.rightContent.reportBug.locationLabel': 'Di manakah pepijat ini ditemui?',
  'components.rightContent.reportBug.locationPlaceholder': 'Pilih Fungsi',
  'components.rightContent.reportBug.locationRequired': 'Sila nyatakan di mana pepijat ini ditemui',
  'components.rightContent.reportBug.descriptionLabel': 'Terangkan isu tersebut',
  'components.rightContent.reportBug.descriptionRequired': 'Sila terangkan isu tersebut',
  'components.rightContent.reportBug.filesLabel': 'Tangkapan Skrin atau Rakaman',
  'components.rightContent.reportBug.uploadText': 'Klik atau seret untuk memuat naik',
  'components.rightContent.reportBug.fileSizeKb': '{size} KB',
  'components.rightContent.reportBug.removeFile': 'Buang {fileName}',
  'components.rightContent.reportBug.deviceLabel': 'Peranti',
  'components.rightContent.reportBug.devicePlaceholder': 'MacBook Pro M1 2021',
  'components.rightContent.reportBug.deviceRequired': 'Sila nyatakan peranti anda',
  'components.rightContent.reportBug.osLabel': 'Sistem pengendalian dan versi',
  'components.rightContent.reportBug.osPlaceholder': 'macOS Sequoia 15.1',
  'components.rightContent.reportBug.osRequired': 'Sila nyatakan OS anda',
  'components.rightContent.reportBug.browserLabel': 'Pelayar',
  'components.rightContent.reportBug.browserPlaceholder': 'Pilih Pelayar',
  'components.rightContent.reportBug.browserRequired': 'Sila nyatakan pelayar anda',
  'components.rightContent.reportBug.submitSuccess': 'Laporan pepijat berjaya dihantar!',
  'components.rightContent.reportBug.submitError':
    'Gagal menghantar laporan pepijat. Sila cuba lagi.',
  'components.rightContent.reportBug.invalidFileType':
    'Anda hanya boleh memuat naik fail imej atau video!',
  'components.rightContent.reportBug.fileUploadSuccess': 'Fail "{fileName}" berjaya dimuat naik!',
  'components.rightContent.reportBug.fileUploadError': 'Gagal memuat naik fail',
  'components.rightContent.reportBug.page.home': 'Laman Utama',
  'components.rightContent.reportBug.page.chat': 'Sembang',
  'components.rightContent.reportBug.page.composer': 'Pengarang',
  'components.rightContent.reportBug.page.review': 'Semakan',
  'components.rightContent.reportBug.page.reference': 'Rujukan',
  'components.rightContent.reportBug.page.files': 'Fail',
  'components.rightContent.reportBug.page.userProfile': 'Profil Pengguna',
  'components.rightContent.reportBug.page.other': 'Lain-lain',
  'components.rightContent.reportBug.browser.chrome': 'Chrome',
  'components.rightContent.reportBug.browser.safari': 'Safari',
  'components.rightContent.reportBug.browser.firefox': 'Firefox',
  'components.rightContent.reportBug.browser.edge': 'Edge',
  'components.rightContent.reportBug.browser.opera': 'Opera',
  'components.rightContent.reportBug.browser.brave': 'Brave',
  'components.rightContent.reportBug.browser.arc': 'Arc',
  'components.rightContent.reportBug.browser.other': 'Lain-lain',
  'components.rightContent.receiptModal.title': 'Terima kasih',
  'components.rightContent.receiptModal.description': 'Laporan anda telah dihantar.',
  'components.scribe.clickToStartRecording': 'Klik untuk mula merakam',
  'components.scribe.failedToGetAuthToken': 'Gagal mendapatkan token pengesahan',
  'components.scribe.failedToStartRecording': 'Gagal memulakan rakaman',
  'components.searchPdfViewerWithHighlight.renderError': 'Gagal memaparkan PDF',
  'components.themeToggle.themeSectionLabel': 'TEMA',
  'components.themeToggle.themeTeal': '🌊 Biru Kehijauan',
  'components.themeToggle.themeMaroon': '🍷 Merah Marun',
  'components.themeToggle.modeSectionLabel': 'MOD',
  'components.themeToggle.lightMode': 'Cerah',
  'components.themeToggle.darkMode': 'Gelap',
  'components.themeToggle.themeSettingsTooltip': 'Tetapan tema',
  'components.whatsNewModal.title': 'Apa yang Baharu',
  'components.whatsNewModal.intro':
    'Kami telah memperkenalkan beberapa ciri baharu untuk mempertingkat proses semakan dokumen anda:',
  'components.whatsNewModal.feature1.title': 'Penapisan Dipertingkat: ',
  'components.whatsNewModal.feature1.description':
    'Penapis khalayak dan penulis baharu untuk membantu anda mencari senarai soalan dengan lebih pantas.',
  'components.whatsNewModal.feature2.title': 'Soalan Ad-hoc: ',
  'components.whatsNewModal.feature2.description':
    'Cara yang lebih fleksibel untuk menambah soalan secara serta-merta.',
  'components.whatsNewModal.feature3.title': 'Penambahbaikan UI: ',
  'components.whatsNewModal.feature3.description':
    'Antara muka yang lebih kemas dan intuitif untuk mengurus {featureName} anda.',
  'components.whatsNewModal.upcomingFeatures.title': 'Ciri Akan Datang',
  'components.whatsNewModal.upcomingFeatures.description':
    'Nantikan lebih banyak kemas kini, termasuk semakan kolaboratif dan analitik AI lanjutan.',
  'components.user.uidLabel': 'UID',
  'components.user.idCopiedMessage': 'ID disalin!',
  'components.file.manager.fetchGroupError': 'Gagal mendapatkan kumpulan: {message}',
  'components.file.manager.fetchFilesError': 'Gagal mendapatkan fail: {message}',
  'components.file.manager.breadcrumbRoot': 'laluan',
  'components.file.manager.breadcrumbBackUpLevel': 'kembali satu aras',
  'components.file.manager.searchPlaceholder': 'cari fail atau folder',
  'components.file.manager.uploadFileButton': 'Muat Naik Fail',
  'components.file.manager.createFolderButton': 'Cipta Folder',
  'components.file.manager.enterButton': 'Masuk',
  'components.file.manager.deleteFolderButton': 'Padam Folder',
  'components.file.manager.deleteFileButton': 'Padam Fail',
  'components.file.manager.uploadedByTime':
    'Dimuat naik oleh: {username}, Masa Dimuat Naik: {createdAt}',
  'components.file.manager.folderNamePlaceholder': 'Nama Folder',
  'components.file.filePreview.cannotPreview': 'Jenis fail ini tidak boleh dipratonton',
  'components.file.documentSelector.sortNameAsc': 'Nama (A-Z)',
  'components.file.documentSelector.sortNameDesc': 'Nama (Z-A)',
  'components.file.documentSelector.sortNewestFirst': 'Terbaharu dahulu',
  'components.file.documentSelector.sortOldestFirst': 'Terlama dahulu',
  'components.file.documentSelector.favourites': 'Kegemaran',
  'components.file.documentSelector.selectedCount': 'Dipilih ({count}):',
  'components.file.documentSelector.selectAllFilesInFolder': 'Pilih semua fail dalam {folderName}',
  'components.file.documentSelector.noFiles': 'Tiada fail',
  'components.file.documentSelector.folderAlt': 'folder',
  'components.file.documentSelector.fileAlt': 'fail',
  'components.file.documentSelector.selectDocuments': 'Pilih dokumen',
  'components.file.documentSelector.selectOkText': 'Pilih',
  'components.file.fileTree.uploadFailed': '{fileName} gagal dimuat naik',
  'components.file.fileTree.clickOrDragToUpload': 'Klik atau seret untuk memuat naik',
  'components.file.fileTree.noFilesUploadedOrSelected': 'Tiada fail dimuat naik atau dipilih lagi.',
  'components.file.selectContext.cannotDeleteDefaultContext':
    'Anda tidak boleh memadam konteks lalai. Sila tetapkan konteks lain sebagai lalai terlebih dahulu.',
  'components.file.selectContext.contextDeleted': 'Konteks dipadam',
  'components.file.selectContext.deleteContextFailed': 'Gagal memadam konteks',
  'components.file.selectContext.enterContextNameWarning': 'Sila masukkan nama konteks',
  'components.file.selectContext.contextCreated': 'Konteks dicipta',
  'components.file.selectContext.cannotUnsetDefaultContext':
    'Anda tidak boleh menyahtetapkan konteks lalai. Sila tetapkan konteks lain sebagai lalai terlebih dahulu.',
  'components.file.selectContext.contextUpdated': 'Konteks dikemas kini',
  'components.file.selectContext.createContextFailed': 'Gagal mencipta konteks',
  'components.file.selectContext.updateContextFailed': 'Gagal mengemas kini konteks',
  'components.file.selectContext.selectContextPresetPlaceholder': 'Pilih pratetap konteks',
  'components.file.selectContext.defaultLabel': '(lalai)',
  'components.file.selectContext.deleteContextConfirmTitle': 'Padam konteks ini?',
  'components.file.selectContext.deleteContextConfirmDescription': 'Ini tidak boleh dibatalkan.',
  'components.file.selectContext.addNewContextTooltip': 'Tambah konteks baharu',
  'components.file.selectContext.modifyContextInfoTooltip': 'Ubah suai maklumat konteks',
  'components.file.selectContext.newContextLabel': 'Konteks baharu',
  'components.file.selectContext.editContextLabel': 'Sunting konteks',
  'components.file.selectContext.contextTitlePlaceholder': 'Tajuk konteks',
  'components.file.selectContext.setAsDefaultLabel': 'Tetapkan sebagai lalai',
  'components.file.selectContext.contextSelectionTitle': 'Pemilihan konteks',
  'components.file.selectContext.noContextSelected': 'Tiada Konteks Dipilih',
  'components.appShell.logoutMenuItem': 'Log keluar',
  'components.appShell.unauthorized.title': 'Halaman ini bukan untuk anda',
  'components.appShell.unauthorized.backHome': 'Kembali ke Laman Utama',
  'components.appShell.promptLibrary.title': 'Pustaka Gesaan',
  'components.appShell.promptLibrary.noPromptsAvailable': 'Tiada gesaan tersedia',
  'components.appShell.promptLibrary.copyTooltip': 'Salin kandungan gesaan',
  'components.appShell.promptLibrary.untitledPrompt': 'Gesaan Tanpa Tajuk',
  'components.appShell.promptLibrary.copiedMessage': 'Gesaan disalin ke papan keratan!',
  'components.appShell.clipboard.title': 'Papan Keratan',
  'components.appShell.clipboard.copiedMessage': 'Disalin!',
  'components.appShell.notFound.title': 'Halaman ini tidak wujud',
  'components.gettingStartedTour.tourTask.chat.title': 'Sembang',
  'components.gettingStartedTour.tourTask.chat.duration': '~1 min',
  'components.gettingStartedTour.tourTask.search.title': 'Carian',
  'components.gettingStartedTour.tourTask.search.duration': '~1 min',
  'components.gettingStartedTour.tourTask.scribe.title': 'Scribe',
  'components.gettingStartedTour.tourTask.scribe.duration': '~2 min',
  'components.gettingStartedTour.tourTask.review.title': 'Semakan',
  'components.gettingStartedTour.tourTask.review.duration': '~3 min',
  'components.gettingStartedTour.tourTask.playbook.title': 'Workstudio',
  'components.gettingStartedTour.tourTask.playbook.duration': '~2 min',
  'components.matrixPolling.processingStoppedMessage': 'Pemprosesan dihentikan',
  'components.matrixPolling.stopProcessingFailedMessage': 'Gagal menghentikan pemprosesan',
  'components.appShell.noResponseError': 'Tiada respons! Sila cuba lagi.',
  'components.appShell.requestError': 'Ralat permintaan, sila cuba lagi.',
  'components.appShell.requestFailedError': 'Permintaan gagal!',
  'components.composerService.socketErrorPrefix': 'Ralat: {message}',
  'components.composerService.sessionDisconnected':
    'Sesi pengarang terputus disebabkan sambungan lain',
  'components.fileViewerWithToken.retrieveFailedError': 'Gagal mendapatkan fail',
  'components.languageSwitcher.switchLanguageTooltip': 'Tukar bahasa',
  'components.crossOrgBadge.sharedByLabel': 'Dikongsi oleh: {orgName}',
  'components.crossOrgBadge.externalOrganization': 'Organisasi Luaran',
  'components.file.sharePoint.fromComputer': 'Dari komputer ini',
  'components.file.sharePoint.fromSharePoint': 'Dari SharePoint / OneDrive',
  'components.file.sharePoint.orAddFromSharePoint': 'atau tambah dari SharePoint / OneDrive',
  'components.file.sharePoint.account': 'Akaun Microsoft',
  'components.file.sharePoint.useDifferentAccount': 'Guna akaun lain',
  'components.file.sharePoint.disconnect': 'Putuskan sambungan',
  'components.file.sharePoint.disconnectConfirm':
    'Putuskan sambungan akaun Microsoft anda daripada A&GEL?',
  'components.file.sharePoint.disconnected': 'Sambungan akaun Microsoft telah diputuskan.',
  'components.file.sharePoint.popupBlocked':
    'Sila benarkan tetingkap timbul untuk A&GEL bagi memilih fail daripada SharePoint.',
  'components.file.sharePoint.consentDeniedTitle': 'Akses SharePoint tidak diluluskan',
  'components.file.sharePoint.consentDenied':
    'Akses SharePoint tidak diluluskan. Jika organisasi anda memerlukan kelulusan pentadbir IT, sila minta pentadbir IT anda meluluskan A&GEL.',
  'components.file.sharePoint.copyApprovalLink': 'Salin pautan kelulusan untuk pentadbir IT anda',
  'components.file.sharePoint.approvalLinkCopied': 'Pautan kelulusan disalin.',
  'components.file.sharePoint.connectFailed':
    'Tidak dapat menyambung ke Microsoft. Sila cuba lagi.',
  'components.file.sharePoint.reconnect': 'Sila sambungkan semula akaun Microsoft anda.',
  'components.file.sharePoint.unsupportedType': '{name} bukan jenis fail yang disokong di sini.',
  'components.file.sharePoint.tooLarge': '{name} terlalu besar (maks {max} MB).',
  'components.file.sharePoint.rejected': '{name} tidak dapat ditambah.',
  'components.file.sharePoint.downloadFailed':
    'Tidak dapat mendapatkan {name} daripada SharePoint. Sila cuba lagi atau muat naik dari komputer anda.',
  'components.file.sharePoint.folderTooLarge':
    'Folder ini terlalu besar untuk diimport sekali gus (maks {max} fail). Sila pilih folder yang lebih kecil.',
  'components.file.sharePoint.chooserTitle': 'Pilih fail',
  'components.file.sharePoint.chooserMyFiles': 'Fail saya',
  'components.file.sharePoint.chooserShared': 'Dikongsi',
  'components.file.sharePoint.chooserFollowedSites': 'Tapak yang diikuti',
  'components.file.sharePoint.chooserSearch': 'Cari tapak',
  'components.file.sharePoint.chooserName': 'Nama',
  'components.file.sharePoint.chooserEmpty':
    'Anda belum mengikuti mana-mana tapak. Cari tapak di atas.',
  'components.file.sharePoint.chooserLocked':
    'Hanya tapak yang anda ikuti atau cari ditunjukkan. Minta pentadbir IT anda meluluskan A&GEL supaya anda boleh menyemak imbas semua tapak.',
  'components.file.sharePoint.chooserLoading': 'Memuatkan…',
  'components.file.sharePoint.chooserSelect': 'Pilih',
  'components.file.sharePoint.chooserCancel': 'Batal',
};
